import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Mandant } from '../../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { SaveForAllDialogComponent } from '../../../dialogs/save-for-all-dialog/save-for-all-dialog.component';
import { Supplier } from '../supplier';
import { SupplierService } from '../supplier.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { FileUploadService } from '../../../dialogs/file-upload-dialog/file-upload.service';
import { ConfirmDeleteDialogComponent } from '../../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { LieferantDokumentFeldMappingDialogComponent } from '../lieferant-dokument-feld-mapping-dialog/lieferant-dokument-feld-mapping-dialog.component';

export class LieferantAnsprechpartner {
    la_id: number;
    lieferant_id: number;
    name: string;
    telefon: string;
    email: string;
}

export class LieferantDokument {
    ld_id: number;
    lieferant_id: number;
    dokument_typ: number;
    tierart_id: number;
    tierart: string;
    bezeichnung: string;
    pdf_id: number;
    dateiname: string;
    feld_mapping?: any;
    hat_mapping?: number;
}

@Component({
    selector: 'kiene-supplier-details',
    templateUrl: './supplier-details.component.html',
    styleUrls: ['./supplier-details.component.scss'],
})
export class SupplierDetailsComponent implements OnInit {
    currentSupplierId: string;
    supplier: Supplier = new Supplier();
    selectedTab = 0;
    isCreationForm = false;

    emailCtrl = new UntypedFormControl('', [Validators.email]);
    faxBevorzugenCtrl = new UntypedFormControl();
    nebenkostenCtrl = new UntypedFormControl();

    availableMandanten: Mandant[] = [];
    uaFormulare: LieferantDokument[] = [];
    ansprechpartner: LieferantAnsprechpartner[] = [];
    ansprechpartnerName = '';
    ansprechpartnerTelefon = '';
    ansprechpartnerEmail = '';
    ansprechpartnerEditId: number = null;

    formularLabel(doc: LieferantDokument): string {
        return doc.bezeichnung || doc.dateiname || '#' + doc.ld_id;
    }

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly location: Location,
        private readonly service: SupplierService,
        private readonly messageService: MessageService,
        private readonly api: KieneTableService,
        public dialog: MatDialog,
        private readonly localStorageService: LocalStorageService,
        private readonly fileUploadService: FileUploadService,
        private readonly pdfViewer: PdfViewerDesktopService,
    ) {
        this.currentSupplierId = this.route.snapshot.paramMap.get('id');
        this.route.queryParams.subscribe(params => {
            this.selectedTab = params['tab'];
        });
    }

    ngOnInit() {
        if (this.currentSupplierId !== 'neu') {
            this.loadSupplier();
        } else {
            this.isCreationForm = true;
            this.loadMandanten();
        }
    }

    goBack() {
        window.history.go(-1);
    }

    loadMandanten() {
        if (this.localStorageService.currentUserHasPermission(1075)) {
            let params = new HttpParams();
            if (!this.isCreationForm) {
                params = params.append('lieferant_id', this.supplier.lieferant_id.toString());
            }
            this.api.get(this.apiBaseUrl + 'lieferant/read_mandanten.php', params).subscribe(
                response => {
                    this.availableMandanten = response.records;
                },
                error => {
                    this.messageService.errorMessage('Fehler beim Laden der verfügbaren Mandanten', error);
                },
            );
        }
    }

    loadSupplier() {
        this.service.getSupplierById(Number.parseInt(this.currentSupplierId, 10)).subscribe(
            response => {
                this.supplier = response;
                this.faxBevorzugenCtrl.setValue(KieneUtils.isApiOne(this.supplier.fax_bevorzugen));
                this.emailCtrl.setValue(this.supplier.email);
                this.nebenkostenCtrl.setValue(KieneUtils.isApiOne(this.supplier.nebenkosten));
                this.loadMandanten();
                this.loadUaFormulare();
                this.loadAnsprechpartner();
            },
            error => {
                this.messageService.errorMessage('Fehler beim Laden des Lieferanten!', error);
            },
        );
    }

    zeigtKreditorNurLesen(): boolean {
        return (
            this.localStorageService.currentUserHasPermission(1082) &&
            !this.localStorageService.currentUserHasPermission(1071) &&
            !this.localStorageService.currentUserHasPermission(1076)
        );
    }

    loadAnsprechpartner() {
        if (!this.supplier?.lieferant_id) {
            return;
        }
        const params = new HttpParams().set('lieferant_id', String(this.supplier.lieferant_id));
        this.api.get(this.apiBaseUrl + 'lieferant_ansprechpartner/read.php', params).subscribe({
            next: response => {
                this.ansprechpartner = response.records || [];
            },
            error: err => {
                this.messageService.errorMessage('Ansprechpartner konnten nicht geladen werden!', err);
            },
        });
    }

    editAnsprechpartner(person: LieferantAnsprechpartner) {
        this.ansprechpartnerEditId = person.la_id;
        this.ansprechpartnerName = person.name || '';
        this.ansprechpartnerTelefon = person.telefon || '';
        this.ansprechpartnerEmail = person.email || '';
    }

    resetAnsprechpartner() {
        this.ansprechpartnerEditId = null;
        this.ansprechpartnerName = '';
        this.ansprechpartnerTelefon = '';
        this.ansprechpartnerEmail = '';
    }

    saveAnsprechpartner() {
        const name = (this.ansprechpartnerName || '').trim();
        if (!name) {
            this.messageService.infoMessage('Bitte einen Namen eintragen.');
            return;
        }
        const body: LieferantAnsprechpartner = {
            la_id: this.ansprechpartnerEditId,
            lieferant_id: this.supplier.lieferant_id,
            name,
            telefon: (this.ansprechpartnerTelefon || '').trim(),
            email: (this.ansprechpartnerEmail || '').trim(),
        };
        this.api.updateGeneric(this.apiBaseUrl + 'lieferant_ansprechpartner/update.php', body).subscribe({
            next: () => {
                this.resetAnsprechpartner();
                this.loadAnsprechpartner();
            },
            error: err => this.messageService.errorMessage('Ansprechpartner konnte nicht gespeichert werden!', err),
        });
    }

    removeAnsprechpartner(person: LieferantAnsprechpartner) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '420px',
            data: {
                title: 'Ansprechpartner löschen',
                text: 'Ansprechpartner ' + person.name + ' wirklich löschen?',
            },
        });
        dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            this.api
                .deleteEntity(this.apiBaseUrl + 'lieferant_ansprechpartner/delete.php', { la_id: person.la_id })
                .subscribe({
                    next: () => {
                        if (this.ansprechpartnerEditId === person.la_id) {
                            this.resetAnsprechpartner();
                        }
                        this.loadAnsprechpartner();
                    },
                    error: err => this.messageService.errorMessage('Löschen fehlgeschlagen!', err),
                });
        });
    }

    loadUaFormulare() {
        if (!this.supplier?.lieferant_id) {
            return;
        }
        if (
            !this.localStorageService.currentUserHasPermission(1071) &&
            !this.localStorageService.currentUserHasPermission(1082) &&
            !this.localStorageService.currentUserHasPermission(1083)
        ) {
            return;
        }
        const params = new HttpParams().set('lieferant_id', String(this.supplier.lieferant_id));
        this.api.get(this.apiBaseUrl + 'lieferant_dokument/read.php', params).subscribe({
            next: response => {
                this.uaFormulare = response.records || [];
            },
            error: err => {
                this.messageService.errorMessage('Untersuchungsformulare konnten nicht geladen werden!', err);
            },
        });
    }

    uploadUaFormular() {
        this.fileUploadService.openAddFilesDialog(
            this.supplier.lieferant_id,
            'lieferant_id',
            'lieferant_dokument/create_ua_formular.php',
            () => this.loadUaFormulare(),
            () => {},
            { formularName: true },
        );
    }

    mapUaFormular(doc: LieferantDokument) {
        const dialogRef = this.dialog.open(LieferantDokumentFeldMappingDialogComponent, {
            width: '96vw',
            maxWidth: '1500px',
            height: '92vh',
            maxHeight: '92vh',
            panelClass: 'feld-mapping-dialog-panel',
            data: { ld_id: doc.ld_id, titel: this.formularLabel(doc) },
        });
        dialogRef.afterClosed().subscribe(ok => {
            if (ok) {
                this.loadUaFormulare();
            }
        });
    }

    showUaFormular(doc: LieferantDokument) {
        this.pdfViewer.openPdfViewer(
            new PdfViewerDialogInput(
                'lieferant_dokument/read_pdf.php',
                new HttpParams().set('ld_id', String(doc.ld_id)),
                doc.dateiname || doc.bezeichnung || 'Untersuchungsformular',
            ),
        );
    }

    removeUaFormular(doc: LieferantDokument) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '25%',
            data: {
                title: 'Formular löschen?',
                text:
                    'Wollen Sie das Formular "' +
                    (doc.bezeichnung || doc.tierart || doc.dateiname) +
                    '" wirklich löschen?',
            },
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.api.deleteEntity(this.apiBaseUrl + 'lieferant_dokument/delete.php', { ld_id: doc.ld_id }).subscribe({
                    next: () => this.loadUaFormulare(),
                    error: err => this.messageService.errorMessage('Löschen fehlgeschlagen!', err),
                });
            }
        });
    }

    updateAllgemein() {
        this.saveSupplier('lieferant/update_allgemein.php');
    }

    updateFibu() {
        this.saveSupplier('lieferant/update_fibu.php');
    }

    updateZahlung() {
        this.saveSupplier('lieferant/update_zahlung.php');
    }

    saveSupplier(apiUrl: string) {
        this.supplier.fax_bevorzugen = this.faxBevorzugenCtrl.value === true ? 1 : 0;
        this.supplier.nebenkosten = this.nebenkostenCtrl.value ? 1 : 0;
        this.supplier.email = this.emailCtrl.value;

        if (this.availableMandanten.length > 1) {
            let dialogRef = this.dialog.open(SaveForAllDialogComponent, {
                data: { availableMandanten: this.availableMandanten },
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    const rawIds = Array.isArray(result) ? result : result.mandanten_ids;
                    this.supplier.mandanten_ids = (rawIds ?? []).map((id: number | string) => Number(id));
                    this.save(apiUrl);
                }
            });
        } else {
            this.save(apiUrl);
        }
    }

    save(apiUrl: string) {
        this.api.updateGeneric(this.apiBaseUrl + apiUrl, this.supplier).subscribe(
            response => {
                this.supplier = response;
                if (this.supplier.lieferant_id) {
                    this.isCreationForm = false;
                    this.currentSupplierId = this.supplier.lieferant_id.toString();
                    this.resetUrl();
                }
                this.messageService.infoMessage(
                    'Lieferant ' + this.supplier.bezeichnung + ' wurde erfolgreich gespeichert!',
                );
            },
            error => {
                this.messageService.errorMessage('Lieferant nicht gespeichert!', error);
            },
        );
    }

    clearEmail() {
        this.emailCtrl.setValue('');
    }

    resetUrl() {
        const url = this.router.createUrlTree([], { relativeTo: this.route }).toString();
        let urlParts = url.split('/');
        let newUrl = '';
        for (let i = 0; i < urlParts.length - 1; i++) {
            newUrl += urlParts[i] + '/';
        }

        newUrl += this.supplier.lieferant_id;

        console.debug('reset url: %s', newUrl);
        this.location.go(newUrl);
    }
}
